module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "home page content",
    class: !_vm.loading && (_vm.latestEpisodes && _vm.latestExtras) ? '' : 'loading'
  }, [_c('hero', {
    attrs: {
      "episode": _vm.featuredEpisode
    }
  }), _vm._v(" "), _c('latest-episodes', {
    attrs: {
      "episodes": _vm.latestEpisodes
    }
  }), _vm._v(" "), _c('call-to-action'), _vm._v(" "), _c('latest-extras', {
    attrs: {
      "extras": _vm.latestExtras
    }
  }), _vm._v(" "), _c('start-here'), _vm._v(" "), _c('testimonials'), _vm._v(" "), _c('shop-module')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07c1b177"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 761
// module chunks = 1